if (!customElements.get('pakiet-life-popup')) {
  customElements.define(
    'pakiet-life-popup',
    class PakietLifePopup extends DrawerComponent {
      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        try {
          this.bundleItems = JSON.parse(this.dataset.items || '[]');
        } catch (e) {
          this.bundleItems = [];
        }
        this.bundleVariantId = Number(this.dataset.bundleVariantId) || null;
        this.threshold = Number(this.dataset.threshold) || 3;
        this.dismissKey = this.dataset.dismissKey || 'pakietLifePopupDismissed';

        if (!this.bundleItems.length || !this.bundleVariantId) return;

        this.ctaBtn = this.querySelector('[data-pakiet-life-cta]');
        this.dismissBtn = this.querySelector('[data-pakiet-life-dismiss]');
        this.itemEls = this.querySelectorAll('.pakiet-life-popup__item');

        this.ctaBtn.addEventListener('click', this.swapToBundle.bind(this));
        // "Zostawiam pojedyncze produkty" idzie przez hide(), które zapisuje odrzucenie (jak krzyżyk, tło i Esc)
        if (this.dismissBtn) this.dismissBtn.addEventListener('click', () => this.hide());

        if (window.PuroPopups) window.PuroPopups.register(this);

        if (Shopify.designMode) return;

        this._checkListener = () => this.fetchCartAndCheck();
        document.addEventListener('cart:updated', this._checkListener);
        window.FoxTheme.DOMready(this._checkListener);
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        if (this._checkListener) {
          document.removeEventListener('cart:updated', this._checkListener);
        }
        if (window.PuroPopups) window.PuroPopups.unregister(this);
      }

      // Odrzucenie na X minut (data-dismiss-minutes) i przerwa dla innych popupów liczą się w koordynatorze
      isDismissed() {
        return window.PuroPopups ? window.PuroPopups.isDismissed(this) : false;
      }
      setDismissed() {
        if (window.PuroPopups) window.PuroPopups.closed(this);
      }

      // Zamknięcie przez klienta (krzyżyk, tło, Esc, przycisk odrzucenia) = rezygnacja
      hide() {
        if (this.open && !this._silent && !Shopify.designMode) this.setDismissed();
        return super.hide();
      }

      // Zamknięcie wynikające z koszyka (warunki przestały być spełnione), bez zapisywania odrzucenia
      silentHide() {
        this._silent = true;
        const result = super.hide();
        this._silent = false;
        return result;
      }

      findInCart(cart, variantId) {
        return cart.items.find((it) => it.variant_id === variantId || it.id === variantId);
      }

      fetchCartAndCheck() {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => this.checkCart(cart))
          .catch(() => {});
      }

      checkCart(cart) {
        if (Shopify.designMode || !cart || !cart.items || this.isDismissed()) return;

        const present = this.bundleItems.filter((bi) => !!this.findInCart(cart, bi.variantId));

        this.itemEls.forEach((li) => {
          const vid = Number(li.dataset.variantId);
          const inCart = present.some((bi) => bi.variantId === vid);
          li.classList.toggle('is-in-cart', inCart);
        });

        if (present.length >= this.threshold) {
          // Koordynator decyduje, czy popup może się teraz pokazać (jeden naraz, wg priorytetu)
          if (window.PuroPopups) window.PuroPopups.request(this);
          else this.show();
        } else {
          if (window.PuroPopups) window.PuroPopups.release(this);
          this.silentHide();
        }
      }

      swapToBundle() {
        if (Shopify.designMode) return;
        this.ctaBtn.disabled = true;

        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            const updates = {};
            this.bundleItems.forEach((bi) => {
              const item = this.findInCart(cart, bi.variantId);
              if (item) updates[item.key] = 0;
            });
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates }),
            });
          })
          .then(() =>
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: this.bundleVariantId, quantity: 1 }),
            })
          )
          .then(() => {
            this.setDismissed();
            this.silentHide();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          })
          .catch((err) => console.error('Pakiet LIFE swap error:', err))
          .finally(() => {
            this.ctaBtn.disabled = false;
          });
      }
    }
  );
}